import React, { useState } from "react";
import { motion } from "framer-motion";
import { LucidePlayCircle } from "lucide-react";


interface DemoModalProps {
  videoSrc?: string;
  isMobile?: boolean;
}

const DemoModal: React.FC<DemoModalProps> = ({
  videoSrc = "https://syncai.ltd/videos/demo.mp4",
  isMobile = false,
}) => {
  const [showVideo, setShowVideo] = useState(false);

  const handleOpenModal = () => {
    setShowVideo(true);
  };

  const handleCloseModal = () => {
    setShowVideo(false);
  };

  return (
    <>
      {/* Demo Button */}
      <button
        onClick={handleOpenModal}
        className="flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
      >
        <LucidePlayCircle className="w-6 h-6 mr-2" />{" "}
        {isMobile ? "Watch Demo" : "Play Demo"}
      </button>

      {/* Demo Modal - Only shows when state is true */}
      {showVideo && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", damping: 20 }}
            className="relative w-full max-w-2xl p-4"
          >
            <button
              onClick={handleCloseModal}
              className="absolute -top-2 right-2 bg-white text-red-600 p-1 rounded-full shadow-md hover:bg-gray-100 flex items-center justify-center"
            >
              <span className="text-sm">x</span>
            </button>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <video controls autoPlay className="w-full">
                <source src={videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default DemoModal;
